class BGStartHub extends HTMLElement {
  connectedCallback() {
    try {
      this.products = JSON.parse(this.querySelector('[data-bg-start-product-json]').textContent);
    } catch (error) {
      console.error('BRAINGAIN Start page product data is invalid.', error);
      return;
    }
    this.warrantyCompleted = false;
    this.currentStep = 1;
    this.cards = [...this.querySelectorAll('[data-bg-start-support-product]')];
    this.panel = this.querySelector('[data-bg-start-panel]');
    this.supportSection = this.querySelector('[data-bg-start-support-section]');
    this.locale = (this.getAttribute('data-bg-start-locale') || 'en').split('-')[0];
    this.selectedHandles = new Set();
    this.bindEvents();
    this.updateSelection();
    const params = new URL(location.href).searchParams;
    const requested = params.get('product');
    (params.get('products') || requested || '').split(',').forEach(handle => {
      if (this.products[handle]) this.selectedHandles.add(handle);
    });
    if (this.selectedHandles.size) this.selectProduct(this.selectedHandles.has(requested) ? requested : [...this.selectedHandles][0], false);
    this.initJourney();
  }

  bindEvents() {
    this.cards.forEach(card => card.addEventListener('click', () => this.toggleProduct(card.getAttribute('data-bg-start-handle'))));
    this.querySelector('[data-bg-start-product-search]')?.addEventListener('input', event => this.filterProducts(event.target.value));
    this.querySelector('[data-bg-start-change-product]')?.addEventListener('click', () => this.showStep(1));
    this.querySelector('[data-bg-start-view-packs]')?.addEventListener('click', () => this.showStep(2));
    this.bindCartForms();
    this.observeWarrantyForm();
  }

  disconnectedCallback() {
    this.warrantyObserver?.disconnect();
    document.removeEventListener('globo.formbuilder.form.submitted', this.onWarrantySuccess);
    this.journeyResize?.disconnect();
  }

  initJourney() {
    this.classList.add('bg-start--wizard');
    this.querySelector('[data-bg-start-journey]').hidden = false;
    this.querySelectorAll('[data-bg-start-go]').forEach(button => button.addEventListener('click', () => this.showStep(Number(button.dataset.bgStartGo))));
    this.querySelector('[data-bg-start-step-select]').addEventListener('change', event => this.showStep(Number(event.target.value)));
    this.querySelector('[data-bg-start-back]').addEventListener('click', () => this.showStep(this.currentStep - 1));
    this.querySelector('[data-bg-start-forward]').addEventListener('click', () => this.showStep(this.currentStep + 1));
    this.querySelector('[data-bg-start-side]').addEventListener('click', () => this.showStep(this.warrantyCompleted ? 4 : 3));
    this.onWarrantySuccess = event => {
      const slot = this.querySelector('[data-bg-start-warranty-slot]');
      const detail = event.detail || {};
      // Globo emits this only after success. Check the actual form belongs to this hub.
      if (!detail.form || !slot?.contains(detail.form)) return;
      const responses = Array.isArray(detail.response) ? detail.response : [detail.response];
      if (!responses.some(response => response?.success === true || response?.success === 'true')) return;
      this.warrantyCompleted = true;
      this.updateJourney();
    };
    document.addEventListener('globo.formbuilder.form.submitted', this.onWarrantySuccess);
    const nav = this.querySelector('[data-bg-start-journey]');
    this.journeyResize = new ResizeObserver(() => this.style.setProperty('--bg-journey-height', `${nav.offsetHeight}px`));
    this.journeyResize.observe(nav);
    this.showStep(this.selectedHandles.size ? 2 : 1, false);
  }

  showStep(step, scroll = true) {
    if (step < 1 || step > 4) return;
    if (step === 2 && !this.selectedHandles.size) step = 1;
    this.currentStep = step;
    this.querySelectorAll('[data-bg-start-step]').forEach(section => section.hidden = Number(section.dataset.bgStartStep) !== step);
    const hero = this.querySelector('.bg-start__hero');
    if (hero) hero.hidden = false;
    // Stop playback when leaving setup without rebuilding the app forms.
    const frame = this.querySelector('[data-bg-start-video] iframe');
    if (step !== 2 && frame) frame.remove();
    if (step === 2 && this.activeHandle) this.renderAssembly(this.products[this.activeHandle]);
    this.filterCrossSells(this.activeHandle || '');
    this.updateJourney();
    const section = this.querySelector(`[data-bg-start-step="${step}"]`);
    if (scroll && section) {
      const heading = this.querySelector('[data-bg-start-header]') || section;
      heading.focus({ preventScroll: true });
      requestAnimationFrame(() => this.smoothScrollTo(heading));
    }
    // Give mounted third-party embeds a chance to measure their newly visible container.
    requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
  }

  updateJourney() {
    if (!this.currentStep) return;
    const activeSection = this.querySelector(`[data-bg-start-step="${this.currentStep}"]`);
    this.setText('[data-bg-start-current-heading]', activeSection?.dataset.journeyTitle);
    this.setText('[data-bg-start-current-intro]', activeSection?.dataset.journeyIntro);
    const offerCopy = this.querySelector('[data-bg-start-header-offer]');
    if (offerCopy) offerCopy.hidden = this.currentStep !== 4;
    this.querySelectorAll('[data-bg-start-go]').forEach(button => {
      const step = Number(button.dataset.bgStartGo);
      button.disabled = step === 2 && !this.selectedHandles.size;
      if (step === this.currentStep) button.setAttribute('aria-current', 'step');
      else button.removeAttribute('aria-current');
      button.classList.toggle('is-registered', step === 3 && this.warrantyCompleted);
    });
    const select = this.querySelector('[data-bg-start-step-select]');
    if (select) {
      select.value = String(this.currentStep);
      select.querySelector('[value="2"]').disabled = !this.selectedHandles.size;
    }
    const back = this.querySelector('[data-bg-start-back]');
    const forward = this.querySelector('[data-bg-start-forward]');
    if (back) back.disabled = this.currentStep === 1;
    if (forward) {
      forward.hidden = this.currentStep === 4;
      forward.disabled = this.currentStep === 1 && !this.selectedHandles.size;
    }
    this.setText('[data-bg-start-step-count]', `${this.dataset.bgStartStepWord || 'Step'} ${this.currentStep} ${this.dataset.bgStartOfWord || 'of'} 4`);
    const progress = this.querySelector('[data-bg-start-progress]');
    if (progress) progress.style.width = `${this.currentStep * 25}%`;
    const side = this.querySelector('[data-bg-start-side]');
    if (side) {
      side.hidden = false;
      this.querySelector('[data-bg-start-side-label]').textContent = this.warrantyCompleted ? side.dataset.offerLabel : side.dataset.warrantyLabel;
      side.classList.toggle('is-offer', this.warrantyCompleted);
    }
  }

  filterProducts(value) {
    const query = value.trim().toLowerCase();
    let visible = 0;
    this.cards.forEach(card => {
      const show = !query || (card.getAttribute('data-bg-start-search') || '').includes(query);
      card.hidden = !show;
      if (show) visible++;
    });
    this.querySelector('[data-bg-start-empty]')?.classList.toggle('is-visible', visible === 0);
  }

  selectionTitles() {
    return [...this.selectedHandles].map(handle => this.products[handle].title).join('; ');
  }

  toggleProduct(handle) {
    if (!this.products[handle]) return;
    if (this.selectedHandles.has(handle)) this.selectedHandles.delete(handle);
    else this.selectedHandles.add(handle);
    if (!this.selectedHandles.size) {
      this.activeHandle = null;
      this.supportSection.hidden = true;
      this.panel.hidden = true;
      const video = this.querySelector('[data-bg-start-video]');
      if (video) video.replaceChildren();
      this.filterCrossSells('');
      const url = new URL(location.href);
      url.searchParams.delete('product');
      url.searchParams.delete('products');
      history.replaceState({}, '', url);
      this.updateSelection();
      return;
    }
    const active = this.selectedHandles.has(handle) ? handle :
      (this.selectedHandles.has(this.activeHandle) ? this.activeHandle : [...this.selectedHandles][0]);
    this.selectProduct(active, false);
  }

  updateSelection() {
    this.cards.forEach(card => {
      const selected = this.selectedHandles.has(card.getAttribute('data-bg-start-handle'));
      card.classList.toggle('is-selected', selected);
      card.setAttribute('aria-pressed', String(selected));
    });
    const count = this.querySelector('[data-bg-start-selection-summary]');
    if (count) count.textContent = `${this.getAttribute('data-bg-start-selected-count-label') || 'Equipment selected:'} ${this.selectedHandles.size}`;
    const button = this.querySelector('[data-bg-start-view-packs]');
    if (button) button.disabled = !this.selectedHandles.size;
    const switcher = this.querySelector('[data-bg-start-pack-switcher]');
    if (switcher) {
      switcher.replaceChildren();
      switcher.hidden = this.selectedHandles.size < 2;
      this.selectedHandles.forEach(handle => {
        const item = document.createElement('button');
        item.type = 'button';
        item.className = 'bg-start__pack-choice';
        item.textContent = this.products[handle].title;
        item.setAttribute('aria-pressed', String(handle === this.activeHandle));
        item.addEventListener('click', () => this.selectProduct(handle, false));
        switcher.appendChild(item);
      });
    }
    this.setHiddenWarrantyProduct(this.selectionTitles());
    this.updateJourney?.();
  }

  selectProduct(handle, shouldScroll) {
    const product = this.products[handle];
    if (!product) return;
    this.selectedHandles.add(handle);
    this.activeHandle = handle;
    this.updateSelection();
    if (this.supportSection) this.supportSection.hidden = this.currentStep !== 2;
    this.panel.hidden = false;
    this.selectedProductTitle = product.title;
    const selectedTitle = this.querySelector('[data-bg-start-selected-title]');
    if (selectedTitle) selectedTitle.textContent = product.title;
let image = this.querySelector('[data-bg-start-selected-image]');

if (!image) {
  image = document.createElement('img');
  image.className = 'bg-start__selected-image';
  image.setAttribute('data-bg-start-selected-image', '');
  image.width = 52;
  image.height = 52;

  const panelHeader = this.querySelector('.bg-start__panel-head');

  if (panelHeader) {
    panelHeader.prepend(image);
  }
}

if (image) {
  image.src =
    product.image ||
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

  image.alt = product.title;
}
    this.renderAssembly(product);
    this.renderManual(product);
    this.filterCrossSells(handle);
    this.setHiddenWarrantyProduct(this.selectionTitles());
    const url = new URL(location.href);
    url.searchParams.set('product', handle);
    url.searchParams.set('products', [...this.selectedHandles].join(','));
    history.replaceState({}, '', url);
    if (shouldScroll) this.showStep(2);
  }

  renderAssembly(product) {
    const videos = product.videos || {};
    const localId = this.videoId(videos[this.locale]);
    const videoId = localId || this.videoId(videos.en);
    const section = this.querySelector('[data-bg-start-assembly]');
    const box = this.querySelector('[data-bg-start-video]');
    if (section) section.hidden = !videoId;
    if (box) {
      box.replaceChildren();
      if (videoId) {
        const frame = document.createElement('iframe');
        frame.loading = 'lazy';
        frame.src = `https://www.youtube-nocookie.com/embed/${videoId}`;
        frame.title = `${product.title} — ${this.getAttribute('data-bg-start-assembly-label') || 'Assembly video'}`;
        frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        frame.allowFullscreen = true;
        box.appendChild(frame);
      }
    }
    this.setText('[data-bg-start-video-note]', product.videoNote);
    const fallback = this.querySelector('[data-bg-start-language-fallback]');
    if (fallback) fallback.hidden = !(videoId && this.locale !== 'en' && !localId);
    this.setLink('[data-bg-start-assembly-contact]', this.contactUrl(product.title));
  }

  renderManual(product) {
    this.setText('[data-bg-start-manual-title]', `${product.title} — ${this.getAttribute('data-bg-start-manual-label') || 'Manual'}`);
    const manual = product.manual && this.safeUrl(product.manual) !== '#' ? product.manual : '';
    this.setLink('[data-bg-start-manual-download]', manual);
    this.querySelector('[data-bg-start-manual-download]')?.closest('.bg-start__action')?.toggleAttribute('hidden', !manual);
    this.querySelector('[data-bg-start-manual-empty]')?.toggleAttribute('hidden', Boolean(manual));
  }

  bindCartForms() {
    this.querySelectorAll('[data-bg-start-cart-form]').forEach(form => {
      const select = form.querySelector('[data-bg-start-variant]');
      select?.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const card = form.closest('[data-bg-start-cross-sell]');
        if (option?.value) {
          card.querySelector('[data-bg-start-price]').textContent = option.dataset.price;
          const compare = card.querySelector('[data-bg-start-compare]');
          compare.textContent = option.dataset.compare || '';
          compare.hidden = !option.dataset.compare;
        }
        const button = form.querySelector('button[type="submit"]');
        button.hidden = false;
        form.classList.remove('is-added', 'has-error');
        button.disabled = !select.value;
        button.textContent = form.dataset.addLabel;
        form.querySelector('[data-bg-start-cart-status]').textContent = '';
      });
      if (select) form.querySelector('button[type="submit"]').disabled = !select.value;
      form.addEventListener('submit', event => {
        event.preventDefault();
        this.addToCart(form);
      });
    });
  }

  async addToCart(form) {
    if (form.dataset.pending === 'true' || !form.reportValidity()) return;
    const button = form.querySelector('button[type="submit"]');
    if (button.disabled) return;
    const payload = new FormData(form);
    if (!payload.get('id')) return;
    const status = form.querySelector('[data-bg-start-cart-status]');
    const select = form.querySelector('[data-bg-start-variant]');
    form.dataset.pending = 'true';
    button.disabled = true;
    if (select) select.disabled = true;
    button.textContent = form.dataset.addingLabel;
    status.textContent = '';
    form.classList.remove('is-added', 'has-error');
    try {
      // Liquid supplies the locale-aware route. Do not retry uncertain requests.
      const url = new URL(form.action, location.origin);
      url.pathname = url.pathname.replace(/\/$/, '') + '.js';
      const response = await fetch(url, { method: 'POST', body: payload, headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error('Cart rejected the addition');
      button.hidden = true;
      form.classList.add('is-added');
      status.textContent = form.dataset.addedLabel;
      this.dispatchEvent(new CustomEvent('bg-start:cart-added', { bubbles: true, detail: result }));
    } catch (error) {
      form.classList.add('has-error');
      button.hidden = false;
      status.textContent = form.dataset.errorLabel;
      button.textContent = form.dataset.addLabel;
      button.disabled = false;
    } finally {
      form.dataset.pending = 'false';
      if (select) select.disabled = false;
      form.querySelector('[data-bg-start-cart-link]').hidden = false;
    }
  }

  filterCrossSells(activeHandle) {
    const ownedIds = new Set([...this.selectedHandles]
      .map(handle => this.products[handle]?.productId)
      .filter(id => id != null && id !== '')
      .map(String));
    let visible = 0;
    const seen = new Set();
    this.querySelectorAll('[data-bg-start-cross-group]').forEach(group => {
      const active = group.getAttribute('data-bg-start-cross-group') === activeHandle;
      group.hidden = !active;
      group.querySelectorAll('[data-bg-start-cross-sell]').forEach(card => {
        const id = card.getAttribute('data-bg-start-product-id');
        const show = active && !ownedIds.has(id) && !seen.has(id);
        card.hidden = !show;
        if (show) { seen.add(id); visible++; }
      });
    });
    const section = this.querySelector('[data-bg-start-cross-section]');
    if (section) section.hidden = visible === 0 || this.currentStep !== 4;
  }

  smoothScrollTo(element) {
    if (!element) return;
    cancelAnimationFrame(this.scrollFrame);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const header = document.querySelector('.section-header, #shopify-section-header, header[role="banner"]');
    const headerHeight = header ? Math.min(header.getBoundingClientRect().height, 140) : 0;
    const start = window.pageYOffset;
    const destination = Math.max(0, element.getBoundingClientRect().top + start - headerHeight - 16);
    if (reduceMotion) { window.scrollTo(0, destination); return; }
    const duration = 900;
    const started = performance.now();
    const ease = value => value < 0.5 ? 4 * value * value * value : 1 - Math.pow(-2 * value + 2, 3) / 2;
    const frame = now => {
      const progress = Math.min((now - started) / duration, 1);
      window.scrollTo(0, start + (destination - start) * ease(progress));
      if (progress < 1) this.scrollFrame = requestAnimationFrame(frame);
    };
    this.scrollFrame = requestAnimationFrame(frame);
  }

  observeWarrantyForm() {
    const root = this.querySelector('[data-bg-start-warranty-slot]');
    if (!root) return;
    const attach = () => {
      const warrantyEmail = root.querySelector('input[type="email"]');
      const offerEmail = this.querySelector('[data-offer-email], .klaviyo-form input[type="email"]');
      if (warrantyEmail && !warrantyEmail.dataset.bgBound) {
        warrantyEmail.dataset.bgBound = 'true';
        warrantyEmail.addEventListener('input', () => { if (offerEmail) offerEmail.value = warrantyEmail.value; });
      }
      if (offerEmail && !offerEmail.dataset.bgBound) {
        offerEmail.dataset.bgBound = 'true';
        offerEmail.addEventListener('input', () => { if (warrantyEmail) warrantyEmail.value = offerEmail.value; });
      }
      this.setHiddenWarrantyProduct(this.selectionTitles());
    };
    this.warrantyObserver?.disconnect();
    this.warrantyObserver = new MutationObserver(attach);
    this.warrantyObserver.observe(root, { childList: true, subtree: true });
    attach();
  }

  setHiddenWarrantyProduct(title) {
    const field = this.querySelector('.globo-formbuilder input[type="hidden"][name="product"], .globo-formbuilder [data-bg-start-warranty-products]');
    if (field && field.value !== title) {
      field.value = title;
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  contactUrl(title) {
    const contactUrl = this.getAttribute('data-bg-start-contact-url') || '';
    if (!contactUrl) return `mailto:${this.getAttribute('data-bg-start-support-email') || 'support@braingain.fit'}?subject=${encodeURIComponent('Setup help: ' + title)}`;
    const separator = contactUrl.includes('?') ? '&' : '?';
    return `${contactUrl}${separator}product=${encodeURIComponent(title)}`;
  }
  setText(selector, value) { const element = this.querySelector(selector); if (!element) return; element.textContent = value || ''; element.hidden = !value; }
  setLink(selector, url) { const element = this.querySelector(selector); if (!element) return; element.href = url || '#'; element.toggleAttribute('aria-disabled', !url); }
  videoId(value = '') {
    const string = String(value || '').trim();
    if (/^[a-zA-Z0-9_-]{11}$/.test(string)) return string;
    try {
      const url = new URL(string);
      const host = url.hostname.replace(/^www\./, '');
      if (!['youtube.com', 'm.youtube.com', 'youtu.be', 'youtube-nocookie.com'].includes(host)) return '';
      const id = url.searchParams.get('v') || url.pathname.split('/').filter(Boolean).pop() || '';
      return /^[a-zA-Z0-9_-]{11}$/.test(id) ? id : '';
    } catch { return ''; }
  }
  safeUrl(value = '') { try { const url = new URL(value, location.origin); return ['http:', 'https:'].includes(url.protocol) ? url.href : '#'; } catch { return '#'; } }
  escape(value = '') { const div = document.createElement('div'); div.textContent = value; return div.innerHTML; }
}
if (!customElements.get('bg-start-hub')) customElements.define('bg-start-hub', BGStartHub);
